<template>
  <div class="verificacao-cpf">
    <div class="loading-text">Para iniciar o atendimento, faça o preenchimento dos seus dados</div>
    <v-form ref="form">
      <div class="d-flex flex-column justify-center align-center" style="width: 400px">
        <v-text-field
          style="width: 400px"
          v-model="cpf"
          label="Digite seu CPF"
          class="search-text-field"
          outlined
          :loading="loadingCpf"
          :disabled="loadingCpf"
          v-mask="'###.###.###-##'"
          :rules="[
            () => $v.cpf.required || 'Campo obrigatório',
            () => $v.cpf.minLength || 'CPF inválido',
            v => validaCpf(v) || 'CPF inválido'
          ]"
        >
        </v-text-field>

        <v-btn
          @click="verificaCpf"
          block
          class="ma-0 pa-0"
          color="primary"
          :loading="loadingCpf"
          :disabled="loadingCpf"
        >
          Buscar
          <v-icon class="ml-8">mdi-magnify</v-icon>
        </v-btn>
        <div class="mt-8" v-if="showAnamneseError">
          <v-alert type="error">
            Anamnese precisar ser finalizada antes do atendimento ser iniciado
          </v-alert>
        </div>
      </div>
    </v-form>
    <ConfirmDialog
      v-if="openBypassFichaClinicaDialog"
      v-model="openBypassFichaClinicaDialog"
      title="Atendimento encontrado"
      text="Identificamos que você já preencheu a ficha clínica deste atendimento, deseja ir direto para a fila de atendimento?"
      cancelButtonText="Revisar dados"
      confirmButtonText="Pular para o atendimento"
      @on-confirm="entrarNaFila"
      @on-cancel="preencherFichaClinica(aso)"
    />
  </div>
</template>
<script>
import atendimentoHibridoService from '@/services/atendimentoHibrido'
import authenticationService from '@/services/authentication'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'
import validaCpf from '@/utils/validaCpf'
import { extractOnlyNumbers } from '@/utils/formatter'
import { mapActions } from 'vuex'
import ConfirmDialog from '@/core/components/ConfirmDialog'

export default {
  mixins: [validationMixin],
  components: {
    ConfirmDialog
  },
  data() {
    return {
      cpf: '',
      loadingCpf: false,
      openBypassFichaClinicaDialog: false,
      idAsoMeetingRoom: null,
      aso: null,
      showAnamneseError: false
    }
  },
  validations: {
    cpf: {
      required,
      minLength: minLength(14)
    }
  },
  methods: {
    ...mapActions('fichaClinica', ['preparaFichaClinica']),
    validaCpf,
    async verificaCpf() {
      if (this.$refs.form.validate()) {
        try {
          this.showAnamneseError = false
          this.loadingCpf = true
          const { data } = await atendimentoHibridoService.validateCpf({
            cpf: extractOnlyNumbers(this.cpf),
            token: this.$route.params.idClinica
          })
          authenticationService.setToken(data.userToken)

          this.$showSuccessMessage(data.message)
          if (data.idAsoMeetingRoom) {
            this.idAsoMeetingRoom = data.idAsoMeetingRoom
            this.aso = { idAso: data.idAso, tipo: data.tipo }
            this.openBypassFichaClinicaDialog = true
          } else {
            this.preencherFichaClinica({ idAso: data.idAso, tipo: data.tipo })
          }
        } catch (error) {
          console.log(error)
          if (error.response.data.anamneseError) {
            this.showAnamneseError = true
          } else {
            this.$showErrorMessage(error.response.data.message)
          }
        } finally {
          this.loadingCpf = false
        }
      }
    },
    async preencherFichaClinica(aso) {
      try {
        this.$showLoading()
        const success = await this.preparaFichaClinica(aso)
        if (success) this.$router.push({ name: 'ficha-clinica-atendimento' })
      } catch (error) {
        console.log(error)
      } finally {
        this.$hideLoading()
      }
    },
    async entrarNaFila() {
      try {
        this.$showLoading()
        const { data } = await atendimentoHibridoService.entrarNaFila(this.aso.idAso)
        this.$router.push({ name: 'fila-atendimento-hibrido', params: { id: data.id } })
      } catch (error) {
        console.log(error)
        this.$showErrorMessage(error.response.data.message)
      } finally {
        this.$hideLoading()
      }
    }
  }
}
</script>
<style scoped>
.verificacao-cpf {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 40px;
  align-items: center;
  justify-content: center;
}

.loading-text {
  font-weight: 700;
  font-size: 1.2rem;
}
</style>
